import BaseTab from '@material-ui/core/Tab'

const Tab = BaseTab

export default Tab
